// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  dbPrefix: '',
  firebaseConfig: {
    apiKey: 'AIzaSyBP1vEEAbAluowu0uo7LR6VG6p-Inz4rxw',
    authDomain: 'trailwerk-530df.firebaseapp.com',
    projectId: 'trailwerk-530df',
    storageBucket: 'trailwerk-530df.appspot.com',
    messagingSenderId: '254027144483',
    appId: '1:254027144483:web:be0387db939eff8f0fc096'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
